// SPEC-402 M1 — replication entry detection + artboard snap (front-end half).
// Mirrors the worker-side gate in worker/src/spec.ts (kept separate: web can't import worker;
// both halves share the same marker list and near-empty definition by convention + PR review).
// SPEC-427 D: the pure detectors (marker lists / isReplicateIntent / insistsNoReference /
// isNoRefReplicaTurn / isNearEmptyCanvas) moved to ./noRef — this file pulls in SidePanel
// (ARTBOARD_PRESETS), whose import chain touches `document` at module init and crashes node
// test bundles. All detectors are re-exported here, so existing import paths stay valid.

import { ARTBOARD_PRESETS } from '../components/SidePanel';

export { isNearEmptyCanvas, insistsNoReference, isNoRefReplicaTurn, isReplicateIntent } from './noRef';

/**
 * Snap the reference image's aspect ratio to the nearest standard artboard preset
 * (design doc §三 入口: 空/新画布自动按参考图宽高比吸附最近预设). Deterministic:
 * aspect-distance comparison, first preset wins ties (array order is fixed).
 */
export function snapArtboardPreset(imgW: number, imgH: number): { key: string; w: number; h: number } {
  const target = imgW / Math.max(1, imgH);
  let best: { key: string; w: number; h: number } = ARTBOARD_PRESETS[0];
  let bestDist = Infinity;
  for (const p of ARTBOARD_PRESETS) {
    const dist = Math.abs(p.w / p.h - target);
    if (dist < bestDist) { best = p; bestDist = dist; }
  }
  return { key: best.key, w: best.w, h: best.h };
}
